module.exports = __webpack_public_path__ + "static/media/label_huidig.0f31ddcf.jpg";